import React from 'react';
import { MAX_SELECTIONS, useTournamentsSelections } from './TournamentsSelectionsProvider';

import './TournamentCheckbox.css';
import { classIf } from '../data/utils/classIf';

function howManySelected(tournaments, map, useUniqueId) {
    let all = true;
    let some = false;
    for (let i = 0; i < tournaments.length; i++) {
        const id = useUniqueId ? tournaments[i].uniqueId : tournaments[i].id;
        if (!map.has(id)) {
            all = false;
            break;
        } else if (!some) {
            some = true;
        }
    }
    return [all, all ? false : some];
}

export default function CategoryCheckbox(props) {
    const tournamentsSelections = useTournamentsSelections();
    
    const [all, some] = howManySelected(props.tournaments, tournamentsSelections.ids, props.useUniqueId);
    const checked = all || some;
    const disabled = !checked && tournamentsSelections.ids.size === MAX_SELECTIONS;

    function handleChange() {
        props.tournaments.forEach(t => {
            const id = props.useUniqueId ? t.uniqueId : t.id;
            if (checked) {
                if (tournamentsSelections.ids.has(id)) {
                    tournamentsSelections.toggleId(id)
                }
            } else {
                if (!tournamentsSelections.ids.has(id)) {
                    tournamentsSelections.toggleId(id)
                }
            }
        });
    }

    return (
        <div className={"xs-tournament-checkbox" + classIf(some, 'incomplete')} onClick={(e) => {e.stopPropagation()}}>
            <label>
                <input type="checkbox"
                    checked={checked}
                    onChange={handleChange}
                    className={"xs-tournament-checkbox" + classIf(disabled, 'disabled')}
                />
                <span className="checkbox"></span>
            </label>
        </div>
    );
}
